<template>
  <div>
    <h1>Heidi Harding</h1>
    
    <img src="../assets/circle-photo.png"/>
    
    <div class="container">
      <div>
        <p style="font-weight: bold">About me</p>
        <p>
          I am a Senior Data Platform Engineer specialising in designing and building scalable data platforms that enable organisations to leverage their data effectively. I architect end-to-end data ecosystems using modern cloud technologies including Azure, Kubernetes, Terraform, and infrastructure-as-code practices.
        </p>

        <p>
          My expertise spans the full data stack - from databases like PostgreSQL and SQL Server to modern data warehouses like Snowflake. I leverage Python for data processing, dbt for transformation workflows, Azure Data Factory for orchestration, and tools like Kafka, and Airflow to build platforms that handle massive scale whilst maintaining high availability and performance.
        </p>

        <p>
          I'm particularly excited about the intersection of AI and data engineering, exploring how machine learning models can be integrated into data pipelines and how AI can optimise platform operations. I also enjoy experimenting with Model Context Protocol (MCP) programming, building custom servers and tools that enhance AI agent capabilities and create more intelligent data workflows. In my spare time, I run local inference experiments on my Mac Studio, exploring the latest language models and their practical applications.
        </p>

        <p>
          When I'm not architecting data solutions, I enjoy photography and mountain biking, capturing the beauty of landscapes and nature. You can see examples of my work here: <a href="https://500px.com/adelheid_de">500px</a>
        </p>
        <PageFooter footer-align="left"></PageFooter>
      </div>
    </div>
  </div>
</template>

<script>
import PageFooter from '../components/PageFooter.vue'
export default {
  name: 'HomeView',
  components: {
    PageFooter
  }
}
</script>

<style scoped>
  
  .container {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .container div {
    width: 600px;
    height: 400px;
  }

  p {
    text-align: left;
    margin-bottom: 10px;
  }

</style>
